var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtgrKids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 7.56356C12.8333 7.07733 12.6402 6.61101 12.2964 6.2672C11.9525 5.92338 11.4862 5.73022 11 5.73022",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.8136C14.0378 15.8136 16.5 12.1194 16.5 7.56355C16.5 6.10486 15.9205 4.70592 14.8891 3.67447C13.8576 2.64302 12.4587 2.06355 11 2.06355C9.54129 2.06355 8.14234 2.64302 7.11089 3.67447C6.07944 4.70592 5.49998 6.10486 5.49998 7.56355C5.49998 12.1194 7.96215 15.8136 11 15.8136ZM11 15.8136V16.7302C11 17.2164 10.8068 17.6828 10.463 18.0266C10.1192 18.3704 9.65288 18.5636 9.16665 18.5636H6.41665C5.93042 18.5636 5.4641 18.7567 5.12028 19.1005C4.77647 19.4443 4.58331 19.9107 4.58331 20.3969",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtgrKids);
export default __webpack_public_path__ + "static/media/ctgr-kids.1f6ebdb51ed97cc0baeeda43e6be0f7d.svg";
export { ForwardRef as ReactComponent };